module.exports = __webpack_public_path__ + "img/3.ee58b16f.jpg";